import actionTypes from '../constants/action-types';

const fetchToken = () => ({
  type: actionTypes.FETCH_TOKEN,
});

export default fetchToken;
